import React, { useEffect, useState } from 'react';
import './Misiuni.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBookOpen,
  faCheckCircle,
  faTrophy,
  faChevronUp,
  faHeart
} from '@fortawesome/free-solid-svg-icons';

import goalImg from '../../../imagesHome/goal.png';
import xpImg from '../../../imagesHome/bolt.png';
import quizMissionImg from '../../../imagesHome/quiz_mission.png';
import puzzleMissionImg from '../../../imagesHome/puzzle_mission.png';

import StatsCard from '../popupsright/StatsCard';
import GetProCard from '../rightelements/GetProCard';
import MotivationalMission from '../rightelements/MotivationalMission';
import FooterElements from '../rightelements/FooterElements';
import SocialElements from '../rightelements/SocialElements';

import './reglaredimensiune.css';

const createMissionsFromDailyData = (dailyData = {}) => {
  const xpToday = Number(dailyData.xp_earned ?? 0);
  const lessonsToday = Number(dailyData.lessons_completed ?? 0);
  const applicationsToday = Number(dailyData.applications_completed ?? 0);

  return [
    {
      text: 'Castiga 30 XP',
      progress: xpToday,
      total: 30,
      icon: faTrophy,
      img: xpImg,
    },
    {
      text: 'Completeaza 3 lectii standard',
      progress: lessonsToday,
      total: 3,
      icon: faBookOpen,
      img: quizMissionImg,
    },
    {
      text: 'Rezolva o lectie aplicativa',
      progress: applicationsToday,
      total: 1,
      icon: faCheckCircle,
      img: puzzleMissionImg,
    },
  ];
};

const learningQuotes = [
  "Maiestria vine celor care persevereaza, nu celor care nu gresesc niciodata.",
  "Invatarea constanta construieste incredere reala.",
  "Progresul mic, repetat zilnic, produce rezultate mari.",
  "Fiecare greseala este un pas spre intelegere.",
  "Disciplina valoreaza mai mult decat motivatia.",
  "Ceea ce exersezi zilnic devine competenta ta.",
  "Succesul nu vine rapid, vine constant.",
  "Invata astazi pentru claritate maine.",
  "Consecventa transforma efortul in expertiza.",
  "Nu renunta. Fiecare intrebare rezolvata conteaza."
];

const Misiuni = () => {

  const apiUrl = process.env.REACT_APP_API_URL;

  const [missions, setMissions] = useState(createMissionsFromDailyData());
  const [quoteOpen, setQuoteOpen] = useState(false);

  const [randomQuote] = useState(
    learningQuotes[Math.floor(Math.random() * learningQuotes.length)]
  );

  useEffect(() => {

    const fetchDailyMissions = async () => {

      try {

        const response = await fetch(`${apiUrl}/missions/today`, {
          method: 'GET',
          credentials: 'include',
        });

        if (!response.ok) return;

        const data = await response.json();

        setMissions(createMissionsFromDailyData(data));

      } catch (error) {
        console.error('Eroare la preluarea misiunilor:', error);
      }

    };

    fetchDailyMissions();

  }, [apiUrl]);

  return (
    <div className="componentsmenu-container-main">

      <div className="componentsmenu-left-blank"></div>

      <div className="componentsmenu-container">

        <StatsCard />

        <div className="missions-card">

          <div className="missions-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span>Misiuni zilnice</span>
            <img src={goalImg} alt="" style={{ width: '28px', height: '28px', objectFit: 'contain' }} />
          </div>

          <div className="missions-list">

            {missions.map((mission, index) => {

              const percent = Math.min(
                100,
                Math.round((mission.progress / mission.total) * 100)
              );

              const isCompleted = percent === 100;

              return (

                <div
                  key={index}
                  className={`mission-item ${isCompleted ? 'mission-completed' : ''}`}
                >

                  <div className="mission-header">

                    <div className="mission-text">
                      {mission.text}
                    </div>

                    <div className="mission-right">

                      <span className="mission-percent">
                        {mission.progress} / {mission.total}
                      </span>

                      <img src={mission.img} alt="" className="mission-flag" style={{ width: '22px', height: '22px', objectFit: 'contain' }} />

                    </div>

                  </div>

                  <div className="mission-progress-bar">

                    <div
                      className="mission-progress-fill"
                      style={{ width: `${percent}%` }}
                    ></div>

                  </div>

                </div>

              );

            })}

          </div>

        </div>
 {/* 
        <div className="quote-card">

          <div
            className="quote-header"
            onClick={() => setQuoteOpen(!quoteOpen)}
          >

            <div>

              <div className="quote-title">
                Ramai motivat!
              </div>

              <div className="quote-date">
                Saptamana 8, 2026
              </div>

            </div>

            <FontAwesomeIcon
              icon={faChevronUp}
              className={`quote-toggle ${!quoteOpen ? "rotated" : ""}`}
            />

          </div>

          {quoteOpen && (
            <>
              <div className="quote-text">
                "{randomQuote}"
              </div>

              <div className="quote-footer">

                <div className="quote-author">
                  ContaLearn AI
                </div>

                <div className="quote-likes">
                  639 <FontAwesomeIcon icon={faHeart} />
                </div>

              </div>
            </>
          )}

        </div>
*/}
      </div>

      <div className="right-elements-componentsmenu">

        <GetProCard />
        <MotivationalMission />
        <FooterElements />
        <SocialElements />

      </div>

    </div>
  );
};

export default Misiuni;